import React from 'react';
import { 
  ChevronLeft, 
  ChevronRight, 
  FirstPage, 
  LastPage 
} from '@mui/icons-material';
import { IconButton, Select, MenuItem, FormControl } from '@mui/material';
import './Pagination.css';

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  pageSizeOptions = [10, 25, 50, 100]
}) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const getVisiblePages = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (let i = Math.max(2, currentPage - delta); 
         i <= Math.min(totalPages - 1, currentPage + delta); 
         i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="pagination-container">
      <div className="pagination-info">
        <span>
          Showing {startItem} to {endItem} of {totalItems} entries
        </span>
      </div>
      
      <div className="pagination-controls">
        <div className="page-size-selector">
          <span>Show</span>
          <FormControl size="small" className="page-size-select">
            <Select
              value={itemsPerPage}
              onChange={(e) => onItemsPerPageChange(e.target.value)}
            >
              {pageSizeOptions.map(size => (
                <MenuItem key={size} value={size}>{size}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <span>entries</span>
        </div>

        <div className="pagination-buttons">
          <IconButton
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
            size="small"
            title="First Page"
          >
            <FirstPage />
          </IconButton>
          
          <IconButton
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            size="small"
            title="Previous Page"
          >
            <ChevronLeft />
          </IconButton>

          <div className="page-numbers">
            {getVisiblePages().map((page, index) => (
              <button
                key={index}
                className={`page-number ${page === currentPage ? 'active' : ''} ${page === '...' ? 'dots' : ''}`}
                onClick={() => typeof page === 'number' && onPageChange(page)}
                disabled={page === '...'}
              >
                {page}
              </button>
            ))}
          </div>

          <IconButton
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            size="small"
            title="Next Page"
          >
            <ChevronRight />
          </IconButton>
          
          <IconButton
            onClick={() => onPageChange(totalPages)}
            disabled={currentPage === totalPages}
            size="small"
            title="Last Page"
          >
            <LastPage />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default Pagination;